export default "__VITE_ASSET__03851211__"